

function login(email, password) {  
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    form_type: 'customer_login',
    utf8: '✓'
  };
  
  var promise = $.ajax({
    url: '/account/login',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true
  });
  return promise;
}

function register(email, password, firstName, lastName, tag) {  
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    'customer[first_name]': firstName,
    'customer[last_name]': lastName,
    'customer[tags]': tag,
    form_type: 'create_customer',
    utf8: '✓'
  };

  var promise = $.ajax({
    url: '/account/login',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true,
    success : function(data){
      alert(data);
    },
    error : function(error){
    	alert(JSON.stringify(error));
    }
  });	
  return promise;
}

//   facebook login 
 

             
             
             
    
// Google login
function onSuccess(googleUser) {
var profile = googleUser.getBasicProfile();
gapi.client.load('plus', 'v1', function () {
     var request = gapi.client.plus.people.get({
       'userId': 'me'
     });
  
        //Display the user details
//         request.execute(function (resp) {
//             var profileHTML = '<div class="profile"><div class="head">Welcome '+resp.name.givenName+'! <a href="javascript:void(0);" onclick="signOut();">Sign out</a></div>';
//             profileHTML += '<img src="'+resp.image.url+'"/><div class="proDetails"><p>'+resp.displayName+'</p><p>'+resp.emails[0].value+'</p><p>'+resp.gender+'</p><p>'+resp.id+'</p><p><a href="'+resp.url+'">View Google+ Profile</a></p></div></div>';
//             $('.userContent').html(profileHTML);
//             $('#gSignIn').slideUp('slow');
//         });
  
  
request.execute(function (response) {
      console.log(response);
      var customers ;
        
   
     if(!false) {
           login(response.emails[0].value ,response.id).done(function (html) {  
           $.get("/account #login_account", function(htmlNew) {          
           if (htmlNew.indexOf('Your Account') != -1) {
              window.location.reload();
             }

            else{
               console.log(response);
               register(response.emails[0].value, response.id, response.name.givenName, response.displayName, "google-login") .done(function(data){
                        var logErrors = $(data).find('.errors').text();

                        //if there are errors show them in the html form
                        if (logErrors != "" && logErrors != 'undefined'){
                            $('#create_customer .errors').html(logErrors);
                            $('#create_customer .errors').show();

                        //if account creation is successful show customer page
                        }else{
                           console.log('success');
                           window.location.reload();
                        }
                        }).fail(function(){console.log('error');});
                         return false;
                        
                }
                
                 });

             });
           } 
        });
    });
}
function onFailure(error) {
    alert(error);
}
function renderButton() {
 gapi.signin2.render('gSignIn', {
        'scope': 'profile email',
        
         
        'longtitle': true,
        'theme': 'dark',
        'onsuccess': onSuccess,
        'onfailure': onFailure
   
    });
}
function renderButton1() {
    gapi.signin2.render('gSignIn1', {
        'scope': 'profile email',    
        'onsuccess': onSuccess,
        'onfailure': onFailure
    });
}

// $(window).load(function(){
//   renderButton();
// });

